/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {map, catchError, tap} from 'rxjs/operators';
import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {APP_CONFIG} from '../app.config';
import {MessageService} from "./message.service";
import {person} from "../model/person";
import {Observable, of} from "rxjs";

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable()
export class PersonService {
  private readonly baseUrl: string;

  constructor(private http: HttpClient,
              private messageService: MessageService) {
    this.baseUrl = inject(APP_CONFIG).baseUrl + '/api/';
  }


  getPerson(Person: person | number): Observable<person> {
    const id = typeof Person === 'number' ? Person : Person.personID;
    const url = `${this.baseUrl}/persons/${id}`;

    return this.http.get<person>(url, httpOptions).pipe(
      tap(_ => this.log('got Person "${Person}"')),
      catchError(this.handleError<person>('getPerson'))
    );
  }

  addPerson(Person:person): Observable<person>{
    const url = `${this.baseUrl}/persons`;

    return this.http.post(url,Person,httpOptions).pipe(
      map(Person => Person as person));
  }

  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  /** Log a message with the MessageService */
  private log(message: string) {
    this.messageService.add('GmPerson: ' + message);
  }
}
